'use client';

import React from 'react';
import { Slide } from '@/shared/types';
import { TagChevronIcon } from '@phosphor-icons/react';

// Interfaces and types
interface HeaderPaneProps {
  slide: Slide;
}

// Component definition
const HeaderPane: React.FC<HeaderPaneProps> = ({ slide }) => {
  // Initialize state
  return (
    <div className='slide-boxes mini text-white'>
      <TagChevronIcon weight="duotone" className='w-4 h-4' />
      <span>{slide.slideSubTitle}</span>
    </div>
  );
}

export default HeaderPane;